<template>
  <footer role="contentinfo">
    <div v-if="route.path !== '/contact' && !route.path.startsWith('/catalog')" class="row footer-banner-columns justify-center items-center gt-sm">
      <div class="col q-pl-lg">
        <div>
          <h2 class="q-pl-md-xl q-pl-md text-white" style="font-size: 2.125rem;
    font-weight: 400;
    line-height: 2.5rem;
    letter-spacing: .00735em;">Ready To Learn More?</h2>
        </div>
      </div>

      <div class="col">
        <div>
          <img src="/assets/homePage/Path43.png" class="white-img" alt="" role="presentation" />
        </div>
      </div>

      <div class="col">
        <div class="float-right">
          <q-btn class="start-free-trial text-bold" label="Contact Us" to="/contact"
            aria-label="Contact us to learn more about ChartFlow" />
        </div>
      </div>
    </div>

    <div class="row q-my-xl full-width justify-center">
      <div class="col-12 col-md-2 q-pa-lg">
        <div class="footer-img-container">
          <q-img src="/assets/homePage/chartflow.png" alt="ChartFlow logo" role="img" />
        </div>
        <div class="footer-caption">
          &copy; 2026 ChartFlow LLC
        </div>
        <div class="text-secondary text-h4">
          <a href="https://www.linkedin.com/company/chartflow/" target="_blank"
            aria-label="Visit ChartFlow on LinkedIn (opens in new tab)" rel="noopener noreferrer">
            <q-icon name="fa-brands fa-linkedin" class="q-mx-xs" aria-hidden="true"></q-icon>
            <q-tooltip>LinkedIn</q-tooltip>
          </a>
          <a href="https://www.youtube.com/@ChartFlow." target="_blank"
            aria-label="Visit ChartFlow on YouTube (opens in new tab)" rel="noopener noreferrer">
            <q-icon name="fa-brands fa-youtube" class="q-mx-xs" aria-hidden="true"></q-icon>
            <q-tooltip>YouTube</q-tooltip>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61573880829456" target="_blank"
            aria-label="Visit ChartFlow on Facebook (opens in new tab)" rel="noopener noreferrer">
            <q-icon name="fa-brands fa-facebook" class="q-mx-xs" aria-hidden="true"></q-icon>
            <q-tooltip>Facebook</q-tooltip>
          </a>
        </div>
      </div>

      <div v-for="(link, index) in footerLinks" :key="index" class="column-item col-12 col-md-2">
        <nav class="content-box q-pa-lg" :aria-label="`${link.title} navigation`">
          <h3 class="content-title">{{ link.title }}</h3>
          <ul class="footer-link-list">
            <li v-for="(menu, idx) in link.options" :key="idx">
              <router-link :to="menu.path ? menu.path : ''"
                :href="menu.href ? menu.href : menu.path" :target="menu.href ? '_blank' : ''"
                :rel="menu.href ? 'noopener noreferrer' : ''"
                :aria-label="menu.href ? `${menu.name} (opens in new tab)` : menu.name" class="content-link cursor-pointer">
                {{ menu.name }}
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <!--
  <div class="col-12 col-md-2">
    <div class="column items-md-end">
      <div class="col q-ml-lg">
        <a href="https://www.linkedin.com/company/chartflow" class="q-mr-md" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
          <img src="/assets/homePage/linkedin.png" alt="" />
        </a>
        <a href="facebook.com" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
          <img src="/assets/homePage/facebook.png" alt="" />
        </a>
      </div>
    </div>
    <div class="column items-md-end">
      <div class="col q-ml-lg">
        <a href="instagram.com" class="q-mr-md" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
          <img src="/assets/homePage/instagram.png" alt="" />
        </a>
        <a href="twitter.com" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
          <img src="/assets/homePage/twitter.png" alt="" />
        </a>
      </div>
    </div>
  </div>
  -->
    </div>
  </footer>
</template>

<script setup>
import { useRoute } from "vue-router";
import { programs } from "../data/marketingPrograms";

defineOptions({
  name: "FooterComponent",
});
const route = useRoute();

const footerLinks = [
  {
    title: "Programs",
    options: programs.map((program) => ({
      name: program.name,
      path: `/programs/${program.slug}`,
    })),
  },
  {
    title: "Resources",
    options: [
      {
        name: "Features",
        path: "/features",
      },
      {
        name: "Course Catalog",
        path: "/catalog",
      },
      {
        name: "Blog",
        href: "https://blog.chartflow.io/"
      },
      {
        name: "Publishing",
        href: "https://publishing.chartflow.io/",
      },
      {
        name: "Help Center",
        href: "https://help.chartflow.io/",
      },
    ],
  },
  {
    title: "Company",
    options: [
      {
        name: "Contact Us",
        path: "/contact",
      },
      {
        name: "Privacy Policy",
        path: "/privacy",
      },
      {
        name: "Terms of Service",
        path: "/terms",
      },
      {
        name: "Accessibility",
        path: "/accessibility",
      },
    ],
  }
];
</script>

<style scoped>
.footer-img-container {
  width: 10rem;
}

.footer-caption {
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: #5a5a5a;
  /* Improved contrast from #868789 to #5a5a5a */
}

.column-item {
  text-align: left;
}

.content-box {
  display: flex;
  flex-flow: column;
}

.content-title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  padding-bottom: 1rem;
  color: #333;
  /* Improved contrast */
}

.content-link {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: #5a5a5a;
  /* Improved contrast from #868789 to #5a5a5a */
  text-decoration: none;
  padding: 0.2rem 0;
}

.content-link:hover {
  color: black;
}

.footer-link-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer-link-list li {
  padding: 0;
}

.footer-banner-columns {
  justify-content: space-between;
  width: 70vw;
  margin: 0 auto;
  background-color: #2f76d3;
  border-radius: 100px;
  padding: 0 3rem;
}

.start-free-trial {
  background-color: white;
  color: #2f76d3;
  border-radius: 30px;
  padding: 8px 6px;
  width: 220px;
  height: 45px;
}

.footer-banner-header {
  color: #fff;
  font-size: 36px;
  font-weight: 600;
}

.footer-banner-button {
  display: flex;
  justify-content: center;
  padding: 2.4rem 0;
  padding-right: 1.5rem;
}
</style>
